import { SectionHubPage } from "../../components/SectionHubPage/SectionHubPage";
import { adminFoundationHubCards } from "../../navigation/appNavigation";
import { SectionLabels } from "../../utils/navigation/pageTitles";

const AdminFoundationHubPage = () => (
    <SectionHubPage
        title={SectionLabels.adminFoundation}
        helmetTitle={SectionLabels.adminFoundation}
        description="Admin entry points: operational settings, sites, and regulatory reference data. Deeper admin screens arrive in later slices."
        cards={adminFoundationHubCards}
    />
);

export { AdminFoundationHubPage };
